<template>
  <BaseLayout>
  	<div>
  	  <h5><font-awesome-icon icon="user-lock" class="icon"/> Informações compartilhadas</h5>
        <br>
        <SharedProfile v-if="loaded" :profile="profile" :disableInput="disableInput" @save="saveRevoke" @back="backRevoke" @revokeAll="revokeAll"></SharedProfile>
        
      </div>
  </BaseLayout>
</template>
<style></style>
<script>
import BaseLayout from '@/components/BaseLayout';
import SharedProfile from '@/components/shared-profile/SharedProfile';
import { mapActions,mapState } from 'vuex';

export default{
  data(){
    return {
      loaded: false,
      disableInput: true,
      id: 0
    }
  },
  components: {
  	BaseLayout,
  	SharedProfile
  },
  created() {
    this.id = this.$route.params.id;
  },
  async mounted(){
    var cgi_id = {'cgi_id': this.id}
    await this.ActionRevokeGetData(cgi_id)
    this.loaded = true
  },
  methods:{
  	saveRevoke: function(formData){
      formData.append( 'cgi_id', this.id)
      this.ActionRevokeSetData(formData)
    },
  	backRevoke: function(){
  	  this.$router.push({name: 'access-locations'});
  	},
    revokeAll: function(){

       let instance = this;

      let message = {
          title: 'Revogar dados de acesso',
          body: 'Quando você utiliza o WISPOT para conectar-se a uma rede WIFI você concede o acesso aos seguintes dados: foto, nome e sobrenome, genero, data de nascimento, documento, telefone e localidade.<br><br>Você pode revogar o acesso a esses dados a qualquer momento. <br><br>Deseja revogar concessão á seus dados pra esta localidade?'                
      };

      let options = {
          html:true,
          okText: 'Sim',
          cancelText: 'Não',
      }


      // Trigger a confirmation dialog
      this.$dialog
      .confirm(message, options)
      .then(async function(dialog) {
          await instance.ActionRevokeAll(instance.id);
          console.log('Clicked on proceed',dialog);
          instance.$router.push({ name: 'access-locations' });

          instance.$toast.success("Revogado com sucesso!", {
              timeout: 10000
          });
      })
      .catch(function(e) {
          console.log(e);
      });


    },
    ...mapActions('revoke', ['ActionRevokeSetData', 'ActionRevokeGetData', 'ActionRevokeAll'])
  },
  computed:{
    ...mapState('revoke', ['profile'])
  }
}
</script>